import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize'
// import 'react-dates/lib/css/_datepicker.css'
import moment from 'moment'
import classNames from 'classnames'
import { withTranslate } from '@i18n/utils'

import Label from '../Label'
import { getRandomness } from 'shared/random-generator'

const DatePicker = ({
    value,
    startOfWeek = 1,
    displayFormat,
    readOnly,
    onChange,
    label,
    disabled,
    focused,
    onFocusChange,
    placeholder,
    translate: t,
    ...datePickerProps
}) => {
    const [isFocused, setIsFocused] = React.useState(focused || false)
    const [date, setDate] = React.useState(value)
    const inputId = React.useMemo(() => `datepicker-${getRandomness()}`, [])

    const onDateChange = value => {
        setDate(value)
        onChange && onChange(value)
    }
    const onFocusChangeHandler = ({ focused }) => {
        setIsFocused(focused)
        onFocusChange && onFocusChange(focused)
    }

    React.useEffect(() => {
        setIsFocused(focused)
    }, [focused])

    // when value changes from props, after initial render
    React.useEffect(() => {
        setDate(value)
    }, [value])

    const keyboardShortcuts = {
        keyboardShortcuts: t('keyboardShortcuts.title'),
        selectFocusedDate: t('keyboardShortcuts.selectDate'),
        moveFocusByOneDay: t('keyboardShortcuts.moveDay'),
        moveFocusByOneWeek: t('keyboardShortcuts.moveWeek'),
        moveFocusByOneMonth: t('keyboardShortcuts.switchMonths'),
        moveFocustoStartAndEndOfWeek: t('keyboardShortcuts.gotoWeek'),
        returnFocusToInput: t('keyboardShortcuts.return'),
        openThisPanel: t('keyboardShortcuts.openPanel'),
    }

    const img = <img src="./icons/ic-date.svg" alt="Date Icon" />
    return (
        <div
            className={classNames(
                'date-picker',
                'date-picker--always-icon',
                {
                    'date-picker--read-only': readOnly,
                },
                datePickerProps.className
            )}>
            <Label htmlFor={inputId}>{label}</Label>
            <SingleDatePicker
                id={inputId}
                disabled={disabled || readOnly}
                numberOfMonths={1}
                firstDayOfWeek={startOfWeek}
                date={date}
                onDateChange={onDateChange}
                displayFormat={displayFormat}
                focused={isFocused}
                onFocusChange={onFocusChangeHandler}
                readOnly={true}
                placeholder={placeholder || <T>subscription.purchase.date.placeholder</T>}
                phrases={keyboardShortcuts}
                renderMonth={m => {
                    const months = moment.localeData().months()
                    return `${months[m.month()]} ${m.format('YYYY')}`
                }}
                {...datePickerProps}
            />
        </div>
    )
}

DatePicker.propTypes = {
    // moment object
    value: PropTypes.shape({}),
    startOfWeek: PropTypes.number,
    onChange: PropTypes.func,
    displayFormat: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    readOnly: PropTypes.bool,
    focused: PropTypes.bool,
    alwaysShowIcon: PropTypes.bool,
}

export default compose(withTranslate)(DatePicker)
